document.addEventListener('DOMContentLoaded', function () {
    const sidebar = document.querySelector('.searchspring-sidebar-class');
    const container = document.querySelector('.searchspring--filter-collection');
  
    function attachButtonListener() {
      const filterButton = document.querySelector('.ss__toolbar__column--filters button');
      if (filterButton && sidebar && container) {
        filterButton.addEventListener('click', function () {
          const isHidden = sidebar.style.display === 'none';
          sidebar.style.display = isHidden ? '' : 'none';
          container.style.gridTemplateColumns = isHidden ? '250px 1fr' : '1fr';
        });
      }
    }
  
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          if (document.querySelector('.ss__toolbar__column--filters button')) {
            attachButtonListener();
            observer.disconnect();
            break;
          }
        }
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });


    if (window.location.pathname === '/search') {
      const params = new URLSearchParams(window.location.search);
      const query = params.get('q');
    
      if (query) {
        const span = document.createElement('span');
        span.textContent = ' FOR "' + query + '".';  
    
        const h1 = document.getElementById('query-text');
        if (h1) {
          h1.appendChild(span); 
        }
      }
    }

  });

